import { render, staticRenderFns } from "./ElderlyOrderJiFen.vue?vue&type=template&id=1c8350ba&scoped=true&"
import script from "./ElderlyOrderJiFen.vue?vue&type=script&lang=js&"
export * from "./ElderlyOrderJiFen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8350ba",
  null
  
)

export default component.exports